import React, { useState, useEffect } from 'react'
import { findIndex, isEmpty } from 'lodash-es'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SelectedExpert from '../../../widgets/selectedExpert/SelectedExpert'
import { getSchemaAssignExpert } from '../../../redux/actions/assignExpert'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function AssignExpert() {
  const SELECTED_EXPERT = 'selectedExpert'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaAssignExpert(projectId)
      // console.log('ssss => ', JSON.stringify(_schema))
      // console.log(JSON.stringify(_schema.model))
      setSchema(_schema.model)

      if(_schema.model?.forms?.ReviewerApproveList?.itemsList?.length > 0){
        console.log('itemsList', _schema.model?.ReviewerApproveList?.itemsList)
        _schema.model?.forms?.ReviewerApproveList?.itemsList.forEach(item => {
          if(!item.isApproved && item.approvedReviewerDate){
            return
          }
          console.log('item',item)
          handleOnClickSelectExpert(null, true, item)
        });
        
      }
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  let _selectedExpert = []
  try {
    _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  } catch (e) {}

  const [selectedExpert, setSelectedExpert] = useState(_selectedExpert)

  useEffect(() => {
    if (!isEmpty(selectedExpert)) {
      sessionStorage.setItem(SELECTED_EXPERT, JSON.stringify(selectedExpert))
    } else {
      sessionStorage.setItem(SELECTED_EXPERT, JSON.stringify([]))
    }
  }, [selectedExpert])

  const handleOnClickSelectExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      console.log('data', data)
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isSelected = true
        } else {
          // newData[dataIndex].isSelected = false
          // newData[dataIndex].isOnline = false

          if (dataIndex > -1) {
            newData.splice(dataIndex, 1)
          }
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            email: data.email,
            isOnline: data.isOnline,
            isSelected: checked,
            isApproved: data.isApproved,
            approvedReviewerDate: data.approvedReviewerDate,
            sendConsiderDate: data.sendConsiderDate,
            reviewType: data.reviewType || '1',
            group: data.group
          },
        ]
      }
    })
  }

  const handleOnClickOnlineExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isOnline = true
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isOnline = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            email: data.email,
            isOnline: checked,
            isSelected: checked,
            reviewType: data.reviewType || '1',
          },
        ]
      }
    })
  }

  const handleOnChangeReviewType = (value, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })

      if (dataIndex !== -1) {
        let newData = [...state]
        newData[dataIndex].reviewType = value
        return newData
      } else {
        return [...state]
      }
    })
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.ProjectInfo} />
      <br />
      <SelectedExpert
        schema={schema.forms}
        selectedExpert={selectedExpert}
        onClickSelectExpert={handleOnClickSelectExpert}
        onClickOnlineExpert={handleOnClickOnlineExpert}
        onChangeReviewType={handleOnChangeReviewType}
      />
      <br />
    </SidebarProposal>
  )
}
